import { ComponentType, FC, useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import { Routes } from 'src/router/route';

/**
 * 웹뷰 전용 페이지에서 적용하는 HOC
 * 웹뷰가 아닌 환경에서 접근시 메인 페이지로 강제 리다이렉션
 */
function withWebviewValidation<Props extends object>(WrappedComponent: ComponentType<Props>) {
  const WithWebviewValidation: FC<Props> = props => {
    const [isValidated, setIsValidated] = useState(false);
    const router = useRouter();
    useEffect(() => {
      if (process.env.NEXT_PUBLIC_ENVIRONMENT !== 'Prod' || window.AzarJs) {
        setIsValidated(true);
      } else {
        router.replace(Routes['/']());
      }
    }, [router]);
    if (!isValidated) return null;
    return <WrappedComponent {...props} data-sentry-element="WrappedComponent" data-sentry-component="WithWebviewValidation" data-sentry-source-file="withWebviewValidation.tsx" />;
  };
  return WithWebviewValidation;
}
export default withWebviewValidation;